import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import Cookies from "universal-cookie";
import { decode } from "base-64";
const cookies = new Cookies();
var token = cookies.get("wmtoken");


export const getUserDetail = async (key) => {
    var fd = new FormData();
    if (token) {
        fd.append("token", decode(token));
        fd.append("identity", API_ENDPOINT.identity);
        fd.append("user_element", key.queryKey[1]);
        key.queryKey[2] && fd.append("screen_name", key.queryKey[2]);
        var res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Profile/getProfileData`, data: fd })
        return await res.data
    }
};
export const getSinglePortfolioDetail = async (type, id, screen_name = null, isVerified = null) => {
    var fd = new FormData();
    if (token) {
        fd.append("token", decode(token));
        fd.append("identity", API_ENDPOINT.identity);
        fd.append("user_element", type);
        fd.append("element_id", id);
        { screen_name && fd.append("screen_name", screen_name) }
        { isVerified && fd.append("is_verified", isVerified) }
        var res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Profile/getProfileData`, data: fd })
        return await res.data[0][0]
    }
};
export const addEducation = async (data) => {
    var fd = new FormData();
    if (token) {
        fd.append("token", decode(token));
        fd.append("identity", API_ENDPOINT.identity);
        fd.append("institute", data.institute);
        fd.append("course_title", data.course_title);
        fd.append("board", data.board);
        fd.append("start_date", data.start_date);
        fd.append("end_date", data.end_date);
        fd.append("grade", data.grade);
        fd.append("grade_privacy", data.grade_privacy ? 1 : 0);
        fd.append("media_privacy", data.media_privacy ? 1 : 0);
        fd.append("education_media", data.mediaSend);
        let res = await axios({ url: `${API_ENDPOINT.apiURL}Profile/createEducationData`, method: 'post', data: fd })
        return await res.data
    }
}
export const addPublication = async (data) => {
    var fd = new FormData();
    if (token) {
        fd.append("token", decode(token));
        fd.append("identity", API_ENDPOINT.identity);
        fd.append("title", data.title);
        fd.append("publishers", data.publishers);
        fd.append("publication_url", data.publication_url);
        fd.append("date_of_publish", data.date_of_publish);
        fd.append("description", data.description);
        fd.append("publication_media", data.mediaSend);
        fd.append("media_privacy", data.media_privacy ? 1 : 0);
        let res = await axios({ url: `${API_ENDPOINT.apiURL}Profile/createPublicationData`, method: 'post', data: fd })
        return await res.data
    }
}
export const addCertification = async (data) => {
    var fd = new FormData();
    if (token) {
        fd.append("token", decode(token));
        fd.append("identity", API_ENDPOINT.identity);
        fd.append("title", data.title);
        fd.append("date", data.date);
        fd.append("description", data.description);
        fd.append("cert_media", data.mediaSend);
        let res = await axios({ url: `${API_ENDPOINT.apiURL}Profile/createCertificationData`, method: 'post', data: fd })
        return await res.data
    }
}
export const addExtraCarriculam = async (data) => {
    var fd = new FormData();
    if (token) {
        fd.append("token", decode(token));
        fd.append("identity", API_ENDPOINT.identity);
        fd.append("title", data.title);
        fd.append("start_date", data.start_date);
        fd.append("end_date", data.end_date);
        fd.append("description", data.description);
        fd.append("media_privacy", data.media_privacy ? 1 : 0);
        fd.append("extraC_media", data.mediaSend);
        fd.append("current_status", data.currently_working ? 1 : 0);
        let res = await axios({ url: `${API_ENDPOINT.apiURL}Profile/createExtraCData`, method: 'post', data: fd })
        return await res.data
    }
}
export const addWorkData = async (data) => {
    var fd = new FormData();
    if (token) {
        fd.append("token", decode(token));
        fd.append("identity", API_ENDPOINT.identity);
        fd.append("title", data.title);
        fd.append("company", data.company);
        fd.append("description", data.work_description);
        fd.append("emp_type", data.emp_type);
        fd.append("start_date", data.start_date);
        fd.append("end_date", data.end_date);
        fd.append("media_privacy", data.media_privacy);
        fd.append("work_media", data.mediaSend);
        fd.append("current_status", data.currently_working ? 1 : 0);
        let res = await axios({ url: `${API_ENDPOINT.apiURL}Profile/createWorkData`, method: 'post', data: fd })
        return await res.data
    }
}
export const addProjectData = async (data) => {
    var fd = new FormData();
    if (token) {
        fd.append("token", decode(token));
        fd.append("identity", API_ENDPOINT.identity);
        fd.append("title", data.title);
        fd.append("project_url", data.project_url);
        fd.append("description", data.description);
        fd.append("start_date", data.start_date);
        fd.append("end_date", data.end_date);
        fd.append("media_privacy", data.media_privacy);
        fd.append("project_media", data.mediaSend);
        fd.append("current_status", data.currently_working ? 1 : 0);
        let res = await axios({ url: `${API_ENDPOINT.apiURL}Profile/createProjectData`, method: 'post', data: fd })
        return await res.data
    }
}
export const updateEducationData = async (data) => {
    var fd = new FormData();
    if (token) {
        fd.append("token", decode(token));
        fd.append("identity", API_ENDPOINT.identity);
        fd.append("institute", data.institute);
        fd.append("edu_id", data.identity);
        fd.append("course_title", data.course_title);
        fd.append("board", data.board);
        fd.append("start_date", data.start_date);
        fd.append("end_date", data.end_date);
        fd.append("grade", data.grade);
        fd.append("grade_privacy", data.grade_privacy ? 1 : 0);
        fd.append("media_privacy", data.media_privacy ? 1 : 0);
        fd.append("education_media", data.mediaSend);
        let res = await axios({ url: `${API_ENDPOINT.apiURL}Profile/updateEducationData`, method: 'post', data: fd })
        return await res.data
    }
}
export const updatePublicationData = async (data) => {
    var fd = new FormData();
    if (token) {
        fd.append("token", decode(token));
        fd.append("identity", API_ENDPOINT.identity);
        fd.append("pub_id", data.identity);
        fd.append("title", data.title);
        fd.append("publishers", data.publishers);
        fd.append("publication_url", data.publication_url);
        fd.append("date_of_publish", data.date_of_publish);
        fd.append("description", data.description);
        fd.append("publication_media", data.mediaSend);
        fd.append("media_privacy", data.media_privacy ? 1 : 0);
        let res = await axios({ url: `${API_ENDPOINT.apiURL}Profile/updatePublicationData`, method: 'post', data: fd })
        return await res.data
    }
}
export const updateCertificationData = async (data) => {
    var fd = new FormData();
    if (token) {
        fd.append("token", decode(token));
        fd.append("identity", API_ENDPOINT.identity);
        fd.append("cert_id", data.identity);
        fd.append("title", data.title);
        fd.append("description", data.description);
        fd.append("date", data.date);
        fd.append("cert_media", data.mediaSend);
        let res = await axios({ url: `${API_ENDPOINT.apiURL}Profile/updateCertificateData`, method: 'post', data: fd })
        return await res.data
    }
}
export const updateExtraCurData = async (data) => {
    var fd = new FormData();
    if (token) {
        fd.append("token", decode(token));
        fd.append("identity", API_ENDPOINT.identity);
        fd.append("ext_id", data.identity);
        fd.append("title", data.title);
        fd.append("start_date", data.start_date);
        fd.append("end_date", data.end_date);
        fd.append("description", data.description);
        fd.append("media_privacy", data.media_privacy ? 1 : 0);
        fd.append("extraC_media", data.mediaSend);
        fd.append("current_status", data.currently_working ? 1 : 0);
        let res = await axios({ url: `${API_ENDPOINT.apiURL}Profile/updateExtraCData`, method: 'post', data: fd })
        return await res.data
    }
}
export const updateWorkData = async (data) => {
    var fd = new FormData();
    if (token) {
        fd.append("token", decode(token));
        fd.append("identity", API_ENDPOINT.identity);
        fd.append("title", data.title);
        fd.append("work_id", data.identity);
        fd.append("company", data.company);
        fd.append("emp_type", data.emp_type);
        fd.append("start_date", data.start_date);
        fd.append("end_date", data.end_date);
        fd.append("media_privacy", data.media_privacy ? 1 : 0);
        fd.append("work_media", data.mediaSend);
        fd.append("description", data.work_description);
        fd.append("current_status", data.currently_working ? 1 : 0);
        let res = await axios({ url: `${API_ENDPOINT.apiURL}Profile/updateWorkData`, method: 'post', data: fd })
        return await res.data
    }
}

export const updateProjectData = async (data) => {
    var fd = new FormData();
    if (token) {
        fd.append("token", decode(token));
        fd.append("identity", API_ENDPOINT.identity);
        fd.append("pro_id", data.identity);
        fd.append("title", data.title);
        fd.append("description", data.description);
        fd.append("project_url", data.project_url);
        fd.append("start_date", data.start_date);
        fd.append("end_date", data.end_date);
        fd.append("media_privacy", data.media_privacy ? 1 : 0);
        fd.append("project_media", data.mediaSend);
        fd.append("current_status", data.currently_working ? 1 : 0);
        let res = await axios({ url: `${API_ENDPOINT.apiURL}Profile/updateProjectData`, method: 'post', data: fd })
        return await res.data
    }
}